export default {
  sm: `
    TECHNOLOGY
    THAT PROTECTS
    THE NATURE,
    ENERGY THAT TAKES
    CARE OF PEOPLE
  `,
  md: `
    TECHNOLOGY
    THAT PROTECTS
    THE NATURE,
    ENERGY THAT TAKES
    CARE OF PEOPLE
  `,
};
